import "./storeEntryBootstrap";
import "./polyfills";
import "./sentry";
import React from "react";

import { QueryClientProvider } from "@tanstack/react-query";

import "@/assets/styles/index.css";
import "@UI/assets/index.scss";

import "@services/axios";
import "@services/i18n";

import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { queryClient } from "@services/queryClient";
import { createRoot } from "react-dom/client";
import { TourTriggerContextProvider } from "@context/TourTriggerContext";
import VisibleNutrientsContextProvider from "@context/VisibleNutrientsContext/VisibleNutrientsContextProvider";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { showAppOutdatedToast } from "@Core/components/VersionToastInfo/showAppOutdatedToast";
import { ENVIRONMENT } from "@config/app";
import DToastContainer from "@UI/components/Molecules/Notification/DToastContainer";
import { applyStoredTheme } from "@UI/hooks/useTheme";

if (typeof window !== "undefined") {
  window.global = window;
}

applyStoredTheme();

window.addEventListener("vite:preloadError", () => {
  showAppOutdatedToast();
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Application root element is missing");

createRoot(rootElement).render(
  <>
    <QueryClientProvider client={queryClient}>
      <TourTriggerContextProvider>
        <VisibleNutrientsContextProvider>
          <App />
        </VisibleNutrientsContextProvider>
      </TourTriggerContextProvider>
      {(ENVIRONMENT ?? "") === "local" ? (
        <ReactQueryDevtools initialIsOpen={false} />
      ) : null}
    </QueryClientProvider>
    <DToastContainer />
  </>,
);

serviceWorker.unregister();
